import {
  ACTION_SET_USER_TYPE,
  IS_APPICANT_TYPE_OTHERS,
} from "../ActionTypes/MemberRegistrationActionTypes";

//set user type from personal details tab
export const setMemberRegistrationUserType = (userTypeId: number) => {
  return {
    type: ACTION_SET_USER_TYPE,
    userTypeId: userTypeId,
  };
};

//check if applicant type is others
export const setIsApplicationTypeOthers = (isApplicantTypeOthers: boolean) => {
  return {
    type: IS_APPICANT_TYPE_OTHERS,
    isApplicantTypeOthers: isApplicantTypeOthers,
  };
};
